import { render, staticRenderFns } from "./pageTitle.vue?vue&type=template&id=4fbb397a&scoped=true"
import script from "./pageTitle.vue?vue&type=script&lang=js"
export * from "./pageTitle.vue?vue&type=script&lang=js"
import style0 from "./pageTitle.vue?vue&type=style&index=0&id=4fbb397a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbb397a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fbb397a')) {
      api.createRecord('4fbb397a', component.options)
    } else {
      api.reload('4fbb397a', component.options)
    }
    module.hot.accept("./pageTitle.vue?vue&type=template&id=4fbb397a&scoped=true", function () {
      api.rerender('4fbb397a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/pageTitle.vue"
export default component.exports